// extracted by mini-css-extract-plugin
module.exports = {"delete-modal":"delete-modal-1v6Mg","deleteModal":"delete-modal-1v6Mg","delete-modal-item":"delete-modal-item-3XQ3-","deleteModalItem":"delete-modal-item-3XQ3-"};